// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bM8X","footer":"styles_footer__Hr6sR","passCodeTooltip":"styles_passCodeTooltip__1HMwz"};